export const heading1 = {
  fontFamily:
    "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
  fontSize: '2.25rem',
  fontWeight: 800,
  lineHeight: 1.2,
  letterSpacing: '-0.0125em',
}
export const heading2 = {
  fontFamily:
    "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
  fontSize: '1.5rem',
  fontWeight: 700,
  lineHeight: 1.3333333,
  letterSpacing: '0em',
}
export const heading3 = {
  fontFamily:
    "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
  fontSize: '1.25rem',
  fontWeight: 600,
  lineHeight: 1.6,
  letterSpacing: '0em',
}
export const heading4 = {
  fontFamily:
    "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
  fontSize: '1rem',
  fontWeight: 600,
  lineHeight: 1.5,
  letterSpacing: '0em',
}
export const body = {
  fontFamily:
    "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
  fontSize: '1rem',
  fontWeight: 400,
  lineHeight: 1.75,
  letterSpacing: '0em',
}
export const bodySm = {
  fontFamily:
    "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
  fontSize: '0.875rem',
  fontWeight: 400,
  lineHeight: 1.75,
  letterSpacing: '0em',
}
export const lead = {
  fontFamily:
    "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
  fontSize: '1.25rem',
  fontWeight: 400,
  lineHeight: 1.6,
  letterSpacing: '0em',
}
export const caption = {
  fontFamily:
    "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: 1.5,
  letterSpacing: '0.025em',
}
export const code = {
  fontFamily:
    "'JetBrains Mono', ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, 'Liberation Mono', monospace",
  fontSize: '0.875rem',
  fontWeight: 400,
  lineHeight: 1.5,
  letterSpacing: '0em',
}
